import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';

interface IProps {
  className?: string;
  showBtn?: boolean;
}

const ErrorView: React.FC<IProps> = ({ showBtn = true, className }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'components.error-view',
  });
  return (
    <Result
      status="warning"
      title={<p className="text-lg">{t('title')}</p>}
      className={`w-full ${className}`}
      extra={
        showBtn && (
          <Link to="/">
            <Button type="primary" key="console">
              {t('button')}
            </Button>
          </Link>
        )
      }
    />
  );
};

export default ErrorView;
